import type { FC, HTMLAttributes, ReactElement } from 'react';

import { useIsPortrait, useIsSmallerThanMedium } from '../../../styles/hooks/media';
import { useModifiers } from '../../../styles/hooks/useModifiers';

import styles from './AutoplayView.module.css';

export interface AutoplayViewProps extends HTMLAttributes<HTMLDivElement> {
  children: [ReactElement, ReactElement, ReactElement, ReactElement];
  footer?: ReactElement;
}

export const AutoplayView: FC<AutoplayViewProps> = ({ children, className, footer, ...rest }) => {
  const mods = useModifiers(styles, 'autoplayView', {}, { withBaseClass: true, extraClassName: className });
  const [betInfo, controls1, controls2, wallet] = children;
  const showWallet = useIsSmallerThanMedium() && useIsPortrait();

  return (
    <>
      <div className={mods} {...rest}>
        <div className={styles.autoplayView__betInfo}>{betInfo}</div>
        <div className={styles.autoplayView__main}>
          {controls1}
          {controls2}
        </div>
        {footer ?? null}
      </div>
      {showWallet ? <div className={styles.autoplayWallet}>{wallet}</div> : null}
    </>
  );
};
